export const SET_SEARCH_AD_TYPES = "set_search_ad_types";
export const SET_SEARCH_PROPERTY_TYPES = "set_search_property_types";
export const SET_SEARCH_ZONES = "set_search_zones";
